﻿import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { KbInput } from "../kb-input/kb-input.component";

@NgComponent({
    token: Token.KbPassword,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbPassword extends KbInput {
    constructor($timeout: ng.ITimeoutService) {
        super($timeout);
        this.restrict = "E";
        this.replace = true;

        this.template = Dirs.component("kb-password");

    }
}
